module.exports = __webpack_public_path__ + "media/assets/good_at/devops-3d4c91d86ac470df776110151a1e8121.png";